import Invoice from '@/models/Invoice';
import InvoiceItem from '@/models/InvoiceItem';
import InvoiceProduct from '@/models/InvoiceProduct';

const GET_INVOICE = 'get_invoice';
const GET_INVOICE_REQUEST = 'get_invoice_request';
const GET_INVOICE_SUCCESS = 'get_invoice_success';
const GET_INVOICE_ERROR = 'get_invoice_error';

export { GET_INVOICE };

export default {
    state: {
        invoice: {
            rows: [],
        },
        loading: false,
        invoiceErrors: [],
    },
    mutations: {
        [GET_INVOICE_REQUEST]: (state) => {
            state.invoice = {
                rows: [],
            };
            state.loading = true;
            state.invoiceErrors = [];
        },
        [GET_INVOICE_SUCCESS]: (state, { invoice, rows }) => {
            state.invoice = invoice;
            state.invoice.rows = rows;
            state.loading = false;
            state.invoiceErrors = [];
        },
        [GET_INVOICE_ERROR]: (state, { errors }) => {
            state.invoice = {
                rows: [],
            };
            state.loading = false;
            state.invoiceErrors = errors;
        }
    },
    actions: {
        [GET_INVOICE]: ({ commit, state, rootState}, { trajectoryId = rootState.trajectory.trajectory.id, invoiceId = state.invoice.id }) => {
            commit(GET_INVOICE_REQUEST);
            return new Promise((resolve, reject) => {
                const TrajectoryInvoice = Invoice.makeModel(`/trajectories/${trajectoryId}/invoices`);
                TrajectoryInvoice.document(invoiceId)
                    .then(invoice => {
                        // Convert JSON to model tree.
                        const url = `/trajectories/${trajectoryId}/invoices/${invoice.id}/rows`;
                        const invoiceItem = InvoiceItem.makeModel(url);
                        const rows = invoice.rows.map(item => {
                            const row = invoiceItem.fromJson(item);
                            row.invoice_product = InvoiceProduct.fromJson(row.invoice_product);
                            return row;
                        });
                        commit(GET_INVOICE_SUCCESS, { invoice, rows });
                        resolve(invoice);
                    })
                    .catch(err => {
                        commit(GET_INVOICE_ERROR, { err });
                        reject(err);
                    });
            });
        }
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/invoice.js